import { useState } from "react";
import api from "../../services/api";

export default function ModalEntregarLlaves({
  isOpen,
  onClose,
  propiedadId,
  referencia,
  theme,
  onDone,
}) {
  const c = theme?.colors || {};
  const isDark = theme?.name === "dark";
  const [agencia, setAgencia] = useState("");
  const [persona, setPersona] = useState("");
  const [telefono, setTelefono] = useState("");
  const [nota, setNota] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const inp = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: `1px solid ${c.border || "#d4d4d8"}`,
    background: isDark ? (c.bgInput || "#1e1e24") : "#fff",
    color: c.textPrimary || "#0f172a",
    fontSize: 14,
    fontFamily: "inherit",
    boxSizing: "border-box",
  };

  const enviar = async () => {
    setError("");
    setSaving(true);
    try {
      const { data } = await api.post(`/propiedades/${propiedadId}/llaves/entregar`, {
        agencia: agencia.trim(),
        persona: persona.trim(),
        telefono: telefono.trim(),
        nota: nota.trim() || null,
      });
      if (data?.ok === false) throw new Error(data.error || "Error");
      const smsErr = data?.data?.sms_error;
      onDone?.(data.data, { smsError: smsErr });
      onClose?.();
    } catch (e) {
      setError(e.response?.data?.error || e.message || "No se pudo registrar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(0,0,0,0.55)",
        fontFamily: "'DM Sans', sans-serif",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(440px, 96vw)",
          borderRadius: 14,
          background: isDark ? c.bgCard : "#fff",
          border: `1px solid ${c.border || "#d4d4d8"}`,
          boxShadow: "0 16px 48px rgba(0,0,0,0.25)",
          padding: "18px 20px 16px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: c.textPrimary }}>
          Entregar llaves a externo
        </h3>
        <p style={{ margin: "8px 0 0", fontSize: 13, color: c.textSecondary }}>
          Ref. <strong>{referencia || "—"}</strong>. Se enviará un SMS con enlace para que confirmen la recogida.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 16 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: c.textMuted }}>Inmobiliaria / agencia *</label>
            <input style={inp} value={agencia} onChange={(e) => setAgencia(e.target.value)} placeholder="Ej: RE/MAX Dénia" />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: c.textMuted }}>Nombre quien recoge *</label>
            <input style={inp} value={persona} onChange={(e) => setPersona(e.target.value)} placeholder="Nombre y apellidos" />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: c.textMuted }}>Teléfono móvil *</label>
            <input style={inp} value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="6XX XXX XXX" inputMode="tel" />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: c.textMuted }}>Nota (opcional)</label>
            <input style={inp} value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Autorizado por propietario…" />
          </div>
        </div>

        {error && (
          <p style={{ margin: "12px 0 0", fontSize: 13, color: "#dc2626" }}>{error}</p>
        )}

        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              flex: 1,
              padding: "11px 14px",
              borderRadius: 10,
              border: `1px solid ${c.border || "#d4d4d8"}`,
              background: "transparent",
              color: c.textPrimary,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={enviar}
            disabled={saving || !agencia.trim() || !persona.trim() || !telefono.trim()}
            style={{
              flex: 1.4,
              padding: "11px 14px",
              borderRadius: 10,
              border: "none",
              background: saving ? "#94a3b8" : "linear-gradient(135deg, #0369a1, #0ea5e9)",
              color: "#fff",
              fontWeight: 700,
              cursor: saving ? "wait" : "pointer",
              fontFamily: "inherit",
            }}
          >
            {saving ? "Enviando…" : "Entregar y enviar SMS"}
          </button>
        </div>
      </div>
    </div>
  );
}
